/*
  Annabelt – Starter Set im Warenkorb (Drawer + Warenkorb-Seite)
  - "Set entfernen": entfernt Parent + alle 0-€-Kopien des Sets in EINEM Aufruf (über Zeilen-Keys)
  - Aufräum-Check nach jeder Warenkorb-Änderung:
      * 0-€-Kopien ohne passendes Parent-Produkt werden entfernt
      * Parent und Kopien bleiben immer bei Menge 1
      * 0-€-Kopien, die jemand einzeln (ohne Set) in den Warenkorb legt, werden entfernt
  Fasst nur Starter-Set-Zeilen an (_ss_role bzw. 0-€-Kopien mit Handle …-starter-set) (BOGOS-Geschenke etc. bleiben unberührt).
*/
(function () {
  if (window.__annabeltStarterSetCart) return;
  window.__annabeltStarterSetCart = true;

  var SOURCE = 'annabelt-starter-set';
  var busy = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: SOURCE } }));
  }

  function isChild(p) { return p && (p._ss_role === 'belt' || p._ss_role === 'buckle'); }

  /* ---------- Set entfernen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-remove]');
    if (!btn) return;
    e.preventDefault();
    var keys = (btn.getAttribute('data-ss-remove') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    btn.setAttribute('disabled', 'disabled');
    var block = btn.closest('.ss-cart-set');
    if (block) block.style.opacity = '0.4';
    busy = true;
    postJSON('/cart/update.js', { updates: updates })
      .then(function (cart) { busy = false; rebuild(cart); })
      .catch(function () { busy = false; window.location.reload(); });
  });

  /* ---------- Aufräum-Check ---------- */
  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p._ss_role === 'parent') parents[p._ss_id] = true;
        });
        var updates = {}, changes = 0;
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (isChild(p) && !parents[p._ss_id]) { updates[it.key] = 0; changes++; return; }
          /* 0-€-Kopie ohne Set (z. B. über Suche/Direktlink einzeln in den Warenkorb gelegt) -> entfernen */
          if (!p._ss_role && /-starter-set$/.test(it.handle || '') && Number(it.final_price) === 0) { updates[it.key] = 0; changes++; return; }
          if ((p._ss_role === 'parent' || isChild(p)) && it.quantity !== 1) { updates[it.key] = 1; changes++; }
        });
        if (!changes) { busy = false; return; }
        return postJSON('/cart/update.js', { updates: updates }).then(function (c) { busy = false; rebuild(c); });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === SOURCE) return;
    setTimeout(check, 250);
  });
  document.addEventListener('cart:quantity', function () { setTimeout(check, 600); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
